<template>
  <div>
    <vue2-org-tree
      v-if="root && isRender"
      :data="root"
      :horizontal="true"
      :collapsable="true"
      :renderContent="renderContent"
      @onExpand="onExpand"
      @onNodeClick="onNodeClick"
    ></vue2-org-tree>

    <vbdi-process-moreinfo-cxlcanhan
      v-if="
            isEnable &&
              selectedNodeType ===
                PROCESS_TREE.NODE_TYPE.PROCESS_NODE
          "
      :isOpen="isOpen"
      :process="selectedNode.vbOutgoingProcess"
      @closeDialog="isOpen = false"
      @closed="isEnable = false"
    />

    <vbdi-process-moreinfo-banhanh
      v-else-if="
            isEnable &&
              selectedNodeType === PROCESS_TREE.NODE_TYPE.BANHANH_NODE
          "
      :isOpen="isOpen"
      :docId="docId"
      @closeDialog="isOpen = false"
      @closed="isEnable = false"
    />
  </div>
</template>
<script>
  import Vue from "vue";
  import Vue2OrgTree from "./vue2-tree/components/org-tree";
  import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
  import h from "../../../services/h";
  import vbFlowInstanceService from "../../../services/vbFlowInstanceService";

  import dateFormatter from "../../../filters/dateFormatter";
  import convertToLabelFilter from "../../../filters/convertToLabelFilter.js";
  import constants from "../../../constants";
  import VbdiProcessMoreinfoCxlcanhan from "./vbdi-process-moreinfo-cxlcanhan";
  import VbdiProcessMoreinfoBanhanh from "./vbdi-process-moreinfo-banhanh";
  import vbdiLuongxulyMixin from "../../../mixins/vbdi-luongxuly-mixin";

  Vue.use(Vue2OrgTree);

  export default {
    name: "vbdi-luong-xu-ly",
    props: ["docId", "flowInstanceId","isForBlockedRole","isConfigLD"],
    mixins: [vbdiLuongxulyMixin],
    filters: {
      dateFormatter,
      convertToLabelFilter
    },

    components: {
      VbdiProcessMoreinfoBanhanh,
      VbdiProcessMoreinfoCxlcanhan,
    },

    data() {
      return {
        nodeInfo: null,
        flowInstance: null,
        isOpen: false,
        isEnable: false,
      };
    },

    watch: {
      isOpen(newValue) {
        newValue && (this.isEnable = newValue);
      },
    },

    computed: {
      selectedNodeType() {
        return this.selectedNode ? this.selectedNode.type : null;
      },

      blockedUserId() {
        return this.$store.getters.lockedUserDeptRole.userId
      }
    },

    created() {
      let loadDocPromise;
      if (this.isConfigLD) {
        loadDocPromise = this.loadDocForConfigLD()
      } else if (this.isForBlockedRole) {
        loadDocPromise = this.loadDocForBlockedRole(this.blockedUserId)
      } else {
        loadDocPromise = this.loadDoc()
      }
      loadDocPromise
        .then(() => this.loadVbFlowInstance())
        .then(() => this.loadVbOutgoingProcess())
        .then(() => this.loadClonedVbIncomingDocs())
        .then(() => this.loadBanHanhDepartments())
        .then(() => this.loadDocReceivers())
        .then(() => this.convertToTreeData())
        .then(() => this.isRender = true)
    },

    methods: {

      loadVbFlowInstance() {
        return vbFlowInstanceService
          .findById(this.flowInstanceId)
          .then(response => (this.flowInstance = response.data));
      },

      loadVbOutgoingProcess() {
        return vbOutgoingProcessService
          .findAllByFlowInstanceId(this.flowInstanceId)
          .then(response => (this.vbOutgoingProcesses = response.data));
      },

      isPhieuYKien() {
        return this.doc && constants.CATEGORY_CODE.PHIEU_Y_KIEN === this.doc.docTypeCode;
      },

      convertToTreeData() {
        let firstVbOutgoingProcess = h.find(
          this.vbOutgoingProcesses,
          item => !item.parentId
        );

        if (firstVbOutgoingProcess) {
          this.root = this.isPhieuYKien()
            ? this.buildTreeDataForHDTVNodes(firstVbOutgoingProcess)
            : this.buildTreeDataForEditorNodes(firstVbOutgoingProcess);
          this.root.children = [this.buildTreeData({}, firstVbOutgoingProcess)];
        }
      },

      /**
       * build node đầu tiên thể hiện người ban hành;
       */
      buildTreeDataForEditorNodes(firstVbOutgoingProcess) {
        let treeNode = {};
        treeNode.id = constants.PROCESS_TREE.NODE_TYPE.EDITOR_NODE;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.EDITOR_NODE;
        treeNode.firstVbOutgoingProcess = firstVbOutgoingProcess;
        return treeNode;
      },

      /**
       * build node đầu tiên thể hiện hội đồng thành viên;
       */
      buildTreeDataForHDTVNodes(firstVbOutgoingProcess) {
        let treeNode = {};
        treeNode.id = constants.PROCESS_TREE.NODE_TYPE.HDTV_NODE;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.HDTV_NODE;
        treeNode.firstVbOutgoingProcess = firstVbOutgoingProcess;
        return treeNode;
      },

      populateForVbOutgoingProcessNode(treeNode, vbOutgoingProcess) {
        treeNode.id = vbOutgoingProcess.id;
        // treeNode.label = `${vbOutgoingProcess.receiverName}`;
        // treeNode.moreInfo = `${vbOutgoingProcess.receiverPosName || ""}`;
        treeNode.expand = true;
        // treeNode.status = vbOutgoingProcess.isRead;
        treeNode.vbOutgoingProcess = vbOutgoingProcess;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.PROCESS_NODE;
        return treeNode;
      },

      buildTreeData(treeNode, vbOutgoingProcess) {
        this.populateForVbOutgoingProcessNode(treeNode, vbOutgoingProcess);

        let childVbOutgoingProcesses = h.findAll(
          this.vbOutgoingProcesses,
          vbOutgoingProcess_ =>
            vbOutgoingProcess_.parentId === vbOutgoingProcess.id
        );

        /**
         * TH: van con node trinh ky dang sau;
         */
        if (childVbOutgoingProcesses && childVbOutgoingProcesses.length) {
          treeNode.children = h.collect(
            childVbOutgoingProcesses,
            nextVbOutgoingProcess => this.buildTreeData({}, nextVbOutgoingProcess)
          );
        } else if (this.flowInstance.status === constants.FLOW_INSTANCE_STATUS.TU_CHOI) {
          treeNode.children = [this.buildTreeDataForTuChoiNodes()];
        } else {
          switch (this.doc.status) {
            case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
              treeNode.children = [this.buildTreeDataForTuChoiBHanhNodes()];
              break;
            case constants.OUTGOING_DOC_STATUS.DABANHANH:
              treeNode.children = [this.buildTreeDataForBanHanhNodes()];
              break;
            case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
              treeNode.children = [this.buildTreeDataForChoBanHanhNode()];
              break;
          }
        }
        return treeNode;
      },

      renderEditorNode(h, data) {
        let doc = this.doc;
        let editorName = this.doc.editorName;
        let classes = [
          "node_handlder flex-row flex__center",
          this.user.id === doc.editorId ? "active" : ""
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(editorName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, editorName)
              // h("div", {class: "more-info font-size__small"}, data.moreInfo)
            ])
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderHDTVNode(h) {
        let doc = this.doc;
        let editorName = "Hội đồng thành viên";
        let classes = [
          "node_handlder flex-row flex__center",
          this.user.id === doc.editorId ? "active" : ""
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(editorName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, editorName)
              // h("div", {class: "more-info font-size__small"}, data.moreInfo)
            ])
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderVbOutgoingProcessNode(h, data) {
        let process = data.vbOutgoingProcess;
        let classes = [
          "node_handlder flex-row flex__center",
          this.user.id === process.receiverId ? "active" : ""
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "profileIsRead"}, [
              h("div", {class: "avatar_fake flex-row flex__center"}, [
                h("span", this.buildShortName(process.receiverName))
              ]),
              process.isRead
                ? h("i", {
                  class:
                    "fas fa-check-circle font-size__medium icon-read border-radius__50"
                })
                : null
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, process.receiverName),
              h(
                "div",
                {class: "more-info font-size__small"},
                process.receiverPosName
              )
            ])
          ])
        );
        return h("div", {class: classes.join(" ")}, components);
      },

      renderContent(h, data) {
        switch (data.type) {
          case constants.PROCESS_TREE.NODE_TYPE.EDITOR_NODE:
            return this.renderEditorNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.HDTV_NODE:
            return this.renderHDTVNode(h);
          case constants.PROCESS_TREE.NODE_TYPE.PROCESS_NODE:
            return this.renderVbOutgoingProcessNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.BANHANH_NODE:
            return this.renderBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CHOBANHANH_NODE:
            return this.renderChoBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE:
            return this.renderDonViBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANHNGOAI_NODE:
            return this.renderDonViBanHanhNgoaiNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE:
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOI_NODE:
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOIBANHANH_NODE:
            return this.renderTuChoiNode(h, data);
        }
      },
    }
  };
</script>
<style scoped>
  .org-tree-node-children {
    vertical-align: middle !important;
  }

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/LuongXuLy.vue